"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styled_1 = require("./styled");
var FlashIcon_1 = require("components/newLTUI/FlashIcon");
var css_1 = require("mobile/utils/css");
var utils_1 = require("pc/components/Products/ProductCardMini/Components/CountDown/utils");
var CountDown = (function (_super) {
    __extends(CountDown, _super);
    function CountDown(props) {
        var _this = _super.call(this, props) || this;
        _this.tick = function () {
            _this.setState(function (preTime) {
                return { endTime: preTime.endTime - 1 };
            });
        };
        _this.state = {
            endTime: +props.countTime
        };
        return _this;
    }
    CountDown.prototype.componentDidMount = function () {
        var _this = this;
        var endTime = this.state.endTime;
        var timerID = setInterval(function () {
            if (endTime > 0) {
                _this.tick();
            }
        }, 1000);
        return function () { return clearInterval(timerID); };
    };
    CountDown.prototype.render = function () {
        var endTime = this.state.endTime;
        var _a = this.props, needIcon = _a.needIcon, style = _a.style;
        if (endTime <= 0) {
            return null;
        }
        return (React.createElement(styled_1.CountDownBox, { style: __assign({}, style) },
            needIcon && React.createElement(FlashIcon_1.FlashIcon, { size: css_1.px2rem(12) }),
            React.createElement(styled_1.Time, null, utils_1.formatSecToDate(endTime))));
    };
    return CountDown;
}(React.Component));
exports.default = CountDown;
